import React, { useState } from 'react';
import Api from '../Auth/Api';
import { Toast } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

function Recuperar() {

    const navigate = useNavigate();

    const [toast, setToast] = useState({});
    const [showToast, setShowToast] = useState(false);

    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await Api.post("/recuperacao-conta", { email });
            setToast({ header: 'Sucesso!', body: response.data.message, type: 'toast-success' });
            setSuccess(true);
            setEmail('');
        } catch (error) {
            setToast({ header: 'Ops!', body: error.response.data.message, type: 'toast-error' });
            console.error(error.response.data.message);
        } finally {
            setLoading(false);
            setShowToast(true);
        }
    };

    return (
        <>
            <Toast
                show={showToast}
                onClose={() => setShowToast(false)}
                delay={4000}
                autohide
                className={`position-fixed top-0 end-0 m-3 toast-icon ${toast.type || 'toast-error'}`}
                style={{ zIndex: 1060 }}
            >
                <Toast.Header>
                    <strong className="me-auto">{toast.header}</strong>
                </Toast.Header>
                <Toast.Body>{toast.body}</Toast.Body>
            </Toast>

            <nav className="navbar bg-primary">
                <div className="container-fluid">
                    <span className="d-flex justify-content-center w-100 navbar-brand m-5px">
                        <img src="./../assets/logo-white.png" className="cursor-pointer" alt="" />
                    </span>
                </div>
            </nav>
            <div className="fade-in w-100">
                <div className="container-fluid login-container">
                    <div className="row align-items-center justify-content-start">
                        <div className="col-12 col-md-12 col-xl-6 mx-md-5">
                            <span onClick={() => navigate(-1)} className="btn btn-link link border-0 fs-6 text-start mb-5"><i className="bi bi-chevron-left"></i>Voltar</span>
                            <form className="d-flex flex-column px-4" onSubmit={handleSubmit}>
                                <div className="d-flex flex-column mb-5">
                                    <h2 className="text-dark fs-4 mb-3">Esqueceu a senha?</h2>
                                    {!success ? (
                                        <p className="text-dark mb-0">Para recuperar sua senha insira o seu email cadastrado e enviaremos a instrução para recuperar sua senha</p>
                                    ) : (
                                        <p className="text-dark mb-0">Senha resetada com sucesso! Por favor, verifique seu email para prosseguir com a recuperação.</p>
                                    )}
                                </div>
                                <div className="mb-3">
                                    <input 
                                        type="email" 
                                        placeholder="Email" 
                                        className="form-control" 
                                        value={email} 
                                        onChange={e => setEmail(e.target.value)} 
                                        required 
                                        disabled={loading || success}
                                    />
                                </div>
                                <div className="d-flex flex-column gap-4">
                                    <button 
                                        type="submit" 
                                        className="btn btn-primary text-light px-4 py-1 py-md-3" 
                                        disabled={loading || success}
                                    >
                                        {loading ? 'Processando...' : 'Recuperar'}
                                    </button>
                                </div>
                            </form>
                        </div>
                        <div className="d-none d-md-block col p-0 spacing-img"></div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Recuperar;